export const PullRequestState = {
  Open: 'OPEN',
  Closed: 'CLOSED',
  Merged: 'MERGED',
} as const

export type PullRequestState = (typeof PullRequestState)[keyof typeof PullRequestState]

export type Repository = {
  id: number
  viewerPermission: string
}

export type PullRequest = {
  id: string
  pathName: string
  aliveChannel: string
  author: {
    login: string
  }
  repository: Repository
  state: PullRequestState
  viewerCanLeaveNonCommentReviews: boolean
  viewerHasViolatedPushPolicy: boolean
  comparison: {
    baseOid: string
    headOid: string
  }
}
